import React, { useState } from "react";

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const MembershipForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    father_name: "",
    phone: "",
    email: "",
    date_of_birth: "",
    blood_group: "",
    adhaar_no: "",
    occupation: "",
    address: "",
    membership_type: "",
    amount: 0,
    photo: null,
  });

  const [preview, setPreview] = useState(null);
  const [acceptedDeclaration, setAcceptedDeclaration] = useState(false);

  const handleChange = (e) => {
    let { name, value, files } = e.target;

    // Capitalize name fields
    if (name === "name" || name === "father_name") value = value.toUpperCase();

    // Only numbers for phone and Aadhaar
    if (name === "phone" || name === "adhaar_no")
      value = value.replace(/\D/g, "");

    // File input
    if (name === "photo") {
      if (files[0] && files[0].size > 10 * 1024 * 1024) {
        alert("File exceeds 10MB");
        return;
      }
      setFormData((prev) => ({ ...prev, photo: files[0] }));
      const reader = new FileReader();
      reader.onload = () => setPreview(reader.result);
      reader.readAsDataURL(files[0]);
      return;
    }

    // Membership type amount
    if (name === "membership_type") {
      let amount = 0;
      if (value === "Lifetime Member") amount = 2000;
      else if (value === "Member") amount = 500;
      else if (value === "Youth Member") amount = 100;
      else if (value === "Volunteer") amount = 100;
      setFormData((prev) => ({ ...prev, membership_type: value, amount }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acceptedDeclaration) {
      alert("Please accept the declaration to proceed.");
      return;
    }

    if (!formData.email.includes("@"))
      return alert("Please enter valid email.");

    try {
      const fd = new FormData();
      for (let key in formData) {
        fd.append(key, formData[key]);
      }

      const res = await fetch(
        "https://crcbharat.com/apis/donations/create_membership_order.php",
        {
          method: "POST",
          body: fd,
        }
      );
      const data = await res.json();
      if (data.error) return alert(data.error);

      const options = {
        key: data.key,
        amount: data.amount * 100,
        currency: "INR",
        name: "CRC BHARAT MEMBERSHIP",
        description: formData.membership_type,
        order_id: data.order_id,
        handler: async function (response) {
          const verifyRes = await fetch(
            "https://crcbharat.com/apis/donations/verify_membership_payment.php",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(response),
            }
          );
          const verifyData = await verifyRes.json();
          if (verifyData.status === "success") {
            alert(`Payment successful! Amount ₹${formData.amount} recorded.`);
          } else {
            alert("Payment verification failed.");
          }
        },
        prefill: {
          name: formData.name,
          email: formData.email,
          contact: formData.phone,
        },
        theme: { color: "#3399cc" },
      };
      new window.Razorpay(options).open();
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-6 border border-blue-200">
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <h1 className="text-4xl font-bold text-blue-900">
                Membership Application
              </h1>
            </div>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Join the Consumer Rights Council and become part of a movement
              dedicated to protecting consumer rights and promoting fair trade
              practices.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Information Sections */}
          <div className="lg:col-span-1 space-y-6">
            {/* Why Become a Member Section */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-blue-500">
              <h2 className="text-xl font-bold text-blue-900 mb-4 flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Why Become a Member?
              </h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  Support initiatives that protect consumers from unfair trade
                  practices
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  Receive guidance on consumer laws and complaint procedures
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  Participate in awareness programs and campaigns
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  Join a recognized network for consumer rights advocacy
                </li>
              </ul>
            </div>

            {/* Member Benefits Section */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-green-500">
              <h2 className="text-xl font-bold text-green-900 mb-4 flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                  />
                </svg>
                Member Benefits
              </h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  Access to consumer protection resources
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  Invitations to seminars and training programs
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  Opportunities for field activities and advocacy
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  Updates on consumer protection laws
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  Membership certificates and recognition
                </li>
              </ul>
            </div>

            {/* Membership Types */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl shadow-lg p-6 text-white">
              <h2 className="text-xl font-bold mb-4">Membership Options</h2>
              <div className="space-y-4">
                <div className="bg-blue-500 bg-opacity-20 p-4 rounded-lg">
                  <h3 className="font-semibold">Lifetime Member</h3>
                  <p className="text-2xl font-bold">₹2,000</p>
                  <p className="text-blue-100 text-sm">One-time payment</p>
                </div>
                <div className="bg-blue-500 bg-opacity-20 p-4 rounded-lg">
                  <h3 className="font-semibold">Member (1 Year)</h3>
                  <p className="text-2xl font-bold">₹500</p>
                  <p className="text-blue-100 text-sm">Annual renewal</p>
                </div>
                <div className="bg-blue-500 bg-opacity-20 p-4 rounded-lg">
                  <h3 className="font-semibold">
                    Youth Member / Volunteer (2 Years)
                  </h3>
                  <p className="text-2xl font-bold">₹100</p>
                  <p className="text-blue-100 text-sm">Two-year validity</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Form Section */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 border-b pb-4">
                Personal Information
              </h2>

              <form
                onSubmit={handleSubmit}
                className="space-y-6"
                encType="multipart/form-data"
              >
                {/* Personal Details Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Father's Name
                    </label>
                    <input
                      type="text"
                      name="father_name"
                      placeholder="Enter father's name"
                      value={formData.father_name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="10-digit mobile number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      maxLength={10}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      name="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg text-base bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none"
                      style={{
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        appearance: "none",
                      }}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Blood Group
                    </label>
                    <select
                      name="blood_group"
                      value={formData.blood_group}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    >
                      <option value="">Select Blood Group</option>
                      {bloodGroups.map((bg) => (
                        <option key={bg} value={bg}>
                          {bg}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Aadhaar Number
                    </label>
                    <input
                      type="text"
                      name="adhaar_no"
                      placeholder="12-digit Aadhaar number"
                      value={formData.adhaar_no}
                      onChange={handleChange}
                      maxLength={12}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Occupation
                    </label>
                    <input
                      type="text"
                      name="occupation"
                      placeholder="Your profession"
                      value={formData.occupation}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                  </div>
                </div>

                {/* Address Field */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Address
                  </label>
                  <input
                    type="text"
                    name="address"
                    placeholder="Your complete address"
                    value={formData.address}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                  />
                </div>

                {/* Photo Upload and Preview */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Profile Photo
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="photo"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                  />

                  {preview && (
                    <div className="mt-4 p-4 border border-gray-300 rounded-lg">
                      <p className="text-sm text-gray-600 mb-3">Preview:</p>
                      <img
                        src={preview}
                        alt="Preview"
                        className="max-w-full h-auto rounded-lg"
                        style={{ maxHeight: "200px" }}
                      />
                    </div>
                  )}
                </div>

                {/* Membership Type Selection */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Membership Type *
                  </label>
                  <select
                    name="membership_type"
                    value={formData.membership_type}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                  >
                    <option value="">Select Membership Type</option>
                    <option value="Lifetime Member">
                      Designated Member / Lifetime – ₹2000
                    </option>
                    <option value="Member">Member 1 year – ₹500</option>
                    <option value="Youth Member">
                      Youth Member 2 years – ₹100
                    </option>
                    <option value="Volunteer">
                      Volunteer 2 years – ₹100
                    </option>
                  </select>
                </div>

                {/* Declaration Section */}
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-yellow-800 mb-4">
                    DECLARATION
                  </h3>
                  <div className="text-sm text-gray-700 space-y-3 max-h-60 overflow-y-auto">
                    <p>
                      I wish to take the Membership of the Consumer Rights
                      Council / उपभोक्ता अधिकार परिषद् for which I am submitting
                      the membership application along with my ID proof.
                      Therefore kindly register me as a member of the council. I
                      promise to be loyal towards the mission of the council and
                      would follow all the rules and regulations which are given
                      to me by council to fulfil its mission.
                    </p>
                    <p>
                      I undertake to abide by the Constitution, rules and
                      discipline of the Council. I do not believe in
                      discrimination based on caste, sex or religion at the same
                      time for any misconduct or deviation of rules or even for
                      not following the disciplinary protocol of organisation
                      the National President may terminate my Membership. I am
                      confirming hare that there is no criminal record or
                      pending cases on me at any police station in our country.
                    </p>
                    <p>
                      I do declare that the membership application fee and
                      contribution (if any) is from my personal fund and
                      voluntary nature.
                    </p>
                  </div>
                  <div className="mt-4 flex items-center">
                    <input
                      type="checkbox"
                      id="declaration"
                      checked={acceptedDeclaration}
                      onChange={(e) => setAcceptedDeclaration(e.target.checked)}
                      className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <label
                      htmlFor="declaration"
                      className="ml-2 text-sm text-gray-700"
                    >
                      I have read and accept the above declaration
                    </label>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={!acceptedDeclaration}
                  className={`w-full py-4 text-white font-bold rounded-xl text-lg transition-all ${acceptedDeclaration
                      ? "bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 shadow-lg hover:shadow-xl"
                      : "bg-gray-400 cursor-not-allowed"
                    }`}
                >
                  {acceptedDeclaration
                    ? `Pay Now - ₹${formData.amount}`
                    : "Please Accept Declaration"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipForm;